// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Image/Ellipse 41.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
}

.services-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  padding: 40px;
}

.service-card {
  background-color: #ffffffad;
  border-radius: 8px;
  border: 1px solid #ffffff80;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.1);
  padding: 30px;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  background-size: 800px;
  background-position: top;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.service-card:hover {
  transform: translateY(-10px);
}

.service-card .image-wrapper img{
  width: 100%;
  max-width: 90px;
  margin-bottom: 14px;
}

.service-card .title {
  font-size: 20px;
  font-weight: 600;
  color: var(--primary-black2);
  margin-bottom: 10px;
}

.service-card .description {
  font-size: 16px;
  color: var(--primary-grey);
}


@media (max-width: 1024px){
  .services-container{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px){
  .services-container{
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 480px){
  .services-container{
    padding: 40px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Service1/Service1.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,yDAA+C;AACjD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;;AAGA;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[":root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n}\n\n.services-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 20px;\n  padding: 40px;\n}\n\n.service-card {\n  background-color: #ffffffad;\n  border-radius: 8px;\n  border: 1px solid #ffffff80;\n  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.3s ease-in-out;\n  background-size: 800px;\n  background-position: top;\n  background-repeat: no-repeat;\n  background-image: url(./Image/Ellipse\\ 41.webp);\n}\n\n.service-card:hover {\n  transform: translateY(-10px);\n}\n\n.service-card .image-wrapper img{\n  width: 100%;\n  max-width: 90px;\n  margin-bottom: 14px;\n}\n\n.service-card .title {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--primary-black2);\n  margin-bottom: 10px;\n}\n\n.service-card .description {\n  font-size: 16px;\n  color: var(--primary-grey);\n}\n\n\n@media (max-width: 1024px){\n  .services-container{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px){\n  .services-container{\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media (max-width: 480px){\n  .services-container{\n    padding: 40px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
